import { swSettings } from "app/common/services/swSettings";
import { isAfterTrial, isMcpNtOrTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export const NO_REACTIVATE_COUNTRIES = ["IN"];

export const shouldSeeReactivationBanner = () => {
    const isNoReactivateUser = [swSettings?.user?.userCountryByIp, swSettings?.user?.userCountry].some((country) =>
        NO_REACTIVATE_COUNTRIES.includes(country),
    );

    return (
        isAfterTrial(swSettings) &&
        !isMcpNtOrTrialOrAfterTrial(swSettings) &&
        !swSettings?.components?.Home?.resources?.CCReactivatedTrial &&
        !isNoReactivateUser
    );
};
